import React, { useState, useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import AssignmentSelectionCard from './AssignmentSelectionCard';

const ITEM_HEIGHT = 72;
const BUFFER = 5;

/**
 * VirtualAssignmentList - Isoliert den Scroll-State und das Virtual Rendering.
 * Verhindert, dass das gesamte ExportModal beim Scrollen neu gerendert wird.
 */
const VirtualAssignmentList = memo(({ 
    items, 
    selectedIds, 
    onToggle, 
    onInfoClick, 
    onHover, 
    onHoverEnd 
}) => {
    const [scrollTop, setScrollTop] = useState(0);

    const onScroll = (e) => {
        setScrollTop(e.target.scrollTop);
    };

    const visibleItems = useMemo(() => {
        const start = Math.max(0, Math.floor(scrollTop / ITEM_HEIGHT) - BUFFER);
        // Wir nehmen hier eine feste Viewport-Höhe von ca 600px an (oder berechnen sie dynamisch)
        const end = Math.min(items.length, Math.floor((scrollTop + 700) / ITEM_HEIGHT) + BUFFER);
        
        return items.slice(start, end).map((item, idx) => ({
            item,
            index: start + idx
        }));
    }, [items, scrollTop]);

    return (
        <div className="details-list-scroll" onScroll={onScroll}>
            <div 
                className="details-list-spacer" 
                style={{ 
                    height: items.length * ITEM_HEIGHT, 
                    position: 'relative',
                    minWidth: '100%' 
                }}
            >
                {visibleItems.map(({ item, index }) => (
                    <AssignmentSelectionCard
                        key={item.id}
                        assignment={item}
                        isSelected={selectedIds.has(String(item.id))}
                        onToggle={onToggle}
                        onClick={onInfoClick}
                        onHover={onHover}
                        onHoverEnd={onHoverEnd}
                        style={{ top: index * ITEM_HEIGHT + 12 }}
                    />
                ))}
                {items.length === 0 && <div className="details-empty">Keine Treffer</div>}
            </div>
        </div>
    );
});

VirtualAssignmentList.displayName = 'VirtualAssignmentList';

VirtualAssignmentList.propTypes = {
    items: PropTypes.array.isRequired,
    selectedIds: PropTypes.instanceOf(Set).isRequired,
    onToggle: PropTypes.func.isRequired,
    onInfoClick: PropTypes.func,
    onHover: PropTypes.func,
    onHoverEnd: PropTypes.func
};

export default VirtualAssignmentList;
